<script lang="ts">
    
    import { gamePoints } from "../../Services/game";

</script>

<div class="game-points">
    <img src="/images/icon-points.svg" alt="">
    <div class="text">
        {$gamePoints} puntos
    </div>
</div>

<style lang="scss">

    .game-points {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 1.3rem;
    }

</style>
